import { render, staticRenderFns } from "./SideModalGadgetList.vue?vue&type=template&id=ffda32e8&scoped=true&"
import script from "./SideModalGadgetList.vue?vue&type=script&lang=ts&"
export * from "./SideModalGadgetList.vue?vue&type=script&lang=ts&"
import style0 from "./SideModalGadgetList.vue?vue&type=style&index=0&id=ffda32e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffda32e8",
  null
  
)

export default component.exports